import IconButton from '@mui/material/IconButton'
import React, { forwardRef } from 'react'
interface geomParamters {
  value:string,
  title:string,
  id:string,
  // refProp?: React.RefObject<HTMLButtonElement>,
  onClick?:any
}
const GeometryButton = forwardRef<HTMLButtonElement, geomParamters>(({value,title,id,onClick}:geomParamters,ref) => {
    const geometryClassName:object={
        point:"esri-widget--button esri-icon-map-pin geometry-button",
        polyline:"esri-widget--button esri-icon-polyline geometry-button",
        polygon:"esri-widget--button esri-icon-polygon geometry-button",
        circle:"esri-widget--button esri-icon-radio-unchecked geometry-button geometry-button-green-theme",
        rectangle:"esri-widget--button esri-icon-checkbox-unchecked geometry-button geometry-button-green-theme",
        text:"esri-widget--button esri-icon-labels geometry-button"
    }
  return (
    <IconButton
    // style={{ backgroundColor: "#14976b", color: "white", borderRadius: "0px 0px 0px 0px", marginLeft: "4px" }}
    className={geometryClassName[value]}
    id={id}
    value={value}
    title={title}
    ref={ref}
    onClick={onClick}
  ></IconButton>
  )
})

export default GeometryButton